/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ID, RIGHT, LEFT, CONFIDENCE, useExaminations, useCurrentExamination } from 'store/examinations';
import AnimateBox from 'components/AnimateBox';
import Message from 'components/Message';

import { handleItems } from './utils';
import { Wrapper, Flex, Item, ItemWrap, Text } from './styles';

const History = ({ side, isOpened }) => {
  const examinations = useExaminations();
  const current = useCurrentExamination(ID);
  const visualAcuities = useMemo(() => handleItems(examinations, current, side), [examinations, current, side]);

  return (
    <AnimateBox isOpen={isOpened}>
      <Wrapper>
        {visualAcuities.length ? (
          visualAcuities.map(({ id, values, date }) => (
            <ItemWrap key={id}>
              <Text>{date}</Text>
              <Flex>
                {values.map(({ items, width }) =>
                  items.map(({ id: subId, value, isRed }, index) => (
                    <Item key={index} width={width} $isRed={isRed}>
                      {(subId === CONFIDENCE && !value && 'Schlecht') || value || '–'}
                    </Item>
                  ))
                )}
              </Flex>
            </ItemWrap>
          ))
        ) : (
          <Message form={1} textAlign="center">
            Keine Historie
          </Message>
        )}
      </Wrapper>
    </AnimateBox>
  );
};

History.propTypes = {
  side: PropTypes.oneOf([RIGHT, LEFT]).isRequired,
  isOpened: PropTypes.bool.isRequired,
};

export default History;
